import { useClientPortalPublicData } from '../../../hooks/use-client-portal-public-data'

export const useProcessingTime = () => {
  const { dataClientPortalPublic } = useClientPortalPublicData()

  const applicationFilingDate = dataClientPortalPublic?.caseInfo?.applicationFiledDate
  const processingTimeData = dataClientPortalPublic?.processingTime
  const processingTimeTrendData = dataClientPortalPublic?.processingTimeTrend
  const inquiryDateTrendData = dataClientPortalPublic?.inquiryTimeTrend

  // Data
  const { processingTime, inquiryIcon, inquiryText } = processingTimeData ?? {}
  const estimatedTime = processingTime?.estimatedTime
  const estimatedTimeUnit = processingTime?.unit

  return {
    inquiryIcon,
    inquiryText,
    estimatedTime,
    estimatedTimeUnit,
    inquiryDateTrendData,
    applicationFilingDate,
    processingTimeTrendData,
  }
}
